export const appColors = {
  base: {
    black: '#000',
    white: '#fff',
  },
  brand: {
    blue: '#007AFF', // #007AFF
    darkGrey: '#58595b',
  },
  menu: {
    background: '#5D5E60',
    selectedHover: '#007AFF6', // brand green with 0.4 opacity
  },
};

// Route paths for site - see routeKeys for export and implementation
const paths = {
  actions: {
    create: '/create',
    delete: '/delete',
    edit: '/edit',
    details: '/details',
    list: '/list',
    permissionDenied: '/permission-denied',
    resetPassword: '/reset-password',
    unprotected: '/login-unprotected',
  },
  errorPages: {
    page403: '/403',
    page404: '/404',
    page500: '/500',
  },
  pages: {
    admin: '/admin',
    app: '/app',
    auth: '/auth',
    booking: '/booking',
    home: '/dashboard',
    login: '/login',
    logout: '/logout',
    modules: '/modules',
    myLearning: '/my-learning',
    students: '/students',
    support: '/support-ticket',
  },
};

export const routeKeys = {
  ...paths.actions,
  ...paths.errorPages,
  ...paths.pages,
};

export const pageTitles = {
  bookings: 'bookings',
  home: 'home',
  modules: 'modules',
  students: 'students',
  support: 'support',
};
